import { createContext, useContext, useRef } from "react";

// Holds a ref whose `.current` is either null (no guard) or an async function
// that returns true (proceed) / false (cancel).
const NavigationGuardContext = createContext({ current: null });

export function NavigationGuardProvider({ children }) {
  const guardRef = useRef(null);
  return (
    <NavigationGuardContext.Provider value={guardRef}>
      {children}
    </NavigationGuardContext.Provider>
  );
}

export function useNavigationGuard() {
  return useContext(NavigationGuardContext);
}
